import { render, staticRenderFns } from "./editPopup.vue?vue&type=template&id=6e895976&scoped=true&"
import script from "./editPopup.vue?vue&type=script&lang=js&"
export * from "./editPopup.vue?vue&type=script&lang=js&"
import style0 from "./editPopup.vue?vue&type=style&index=0&id=6e895976&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e895976",
  null
  
)

export default component.exports